module.exports = __webpack_public_path__ + "img/icon-transfer.31eee3f4.png";